import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useEarlyAccess } from '../EarlyAccessContext';
import logo from '../assets/img/nx-logo-nobg.png';

function Navbar() {
  const openEarlyAccess = useEarlyAccess();

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      if (navbar) {
        if (window.scrollY > 45) {
          navbar.classList.add('sticky-top', 'shadow-sm');
        } else {
          navbar.classList.remove('sticky-top', 'shadow-sm');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="main-header">
      <div className="container position-relative p-0">
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
          <NavLink to="/" className="navbar-brand p-0 d-flex align-items-center gap-2">
            <img src={logo} alt="NexVeda Networks" className="logo-header" />
            <span className="navbar-brand-name">NexVeda<br /><span className="navbar-brand-sub">Networks</span></span>
          </NavLink>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
            <span className="fa fa-bars"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0 pe-4">
              <NavLink to="/" className={({ isActive }) => `nav-item nav-link ${isActive ? 'active' : ''}`} end>Home</NavLink>
              <NavLink to="/product" className={({ isActive }) => `nav-item nav-link ${isActive ? 'active' : ''}`}>Product</NavLink>
              <NavLink to="/services" className={({ isActive }) => `nav-item nav-link ${isActive ? 'active' : ''}`}>Services</NavLink>
              <NavLink to="/about" className={({ isActive }) => `nav-item nav-link ${isActive ? 'active' : ''}`}>About</NavLink>
            </div>
            <button onClick={openEarlyAccess} className="btn-get-started">Early Access</button>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Navbar;
